import styled from 'styled-components';

export const HeaderButtonContainer = styled.div`
	display: flex;
	gap: 1rem;
	position: absolute;
	right: 30px;
	top: 25px;

	@media (min-width: 0) and (max-width: 768px) {
		flex-direction: column;
		position: relative;
		top: 12px;
		right: 0;
	}
`;
HeaderButtonContainer.displayName = 'HeaderButtonContainer';
